module.exports = __webpack_public_path__ + "img/sequence-suidobashi@2x.d47a67a2.jpg";